import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label } from 'reactstrap';
import { useState } from 'react';

interface WarningModalProps {
  isOpen: boolean;
  onConfirm: (dontRemind: boolean) => void;
  onCancel: () => void;
}

export const WarningModal = ({ isOpen, onConfirm, onCancel }: WarningModalProps) => {
  const [dontRemind, setDontRemind] = useState(false);

  const handleConfirm = () => {
    onConfirm(dontRemind);
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>Warning</ModalHeader>
      <ModalBody>
        <p>
          Changing the aggregation type globally impacts all existing combined reports upon data refresh (and all future
          combined reports).
        </p>
        <FormGroup check>
          <Input
            id={'notShowAgain'}
            type='checkbox'
            checked={dontRemind}
            onChange={(e) => setDontRemind(e.target.checked)}
          />
          <Label htmlFor='notShowAgain' check>
            Don't remind me again
          </Label>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color='primary' onClick={handleConfirm}>
          Change aggregation type
        </Button>
        <Button color='secondary' onClick={onCancel}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
